module.exports = __webpack_public_path__ + "img/restaurant_bodyimage05.e6c77098.jpg";